import { render } from "./FormOcDipendente.vue?vue&type=template&id=31ad5b32"
import script from "./FormOcDipendente.vue?vue&type=script&lang=js"
export * from "./FormOcDipendente.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__